import { createApp, markRaw } from "vue";
import App from "@/App.vue";
import DisableAutocomplete from "@/mixins/DisableAutocomplete";
import pluralize from "pluralize";
import {
  titleize,
  abbreviateNumber,
  audienceAvailability,
  audienceType,
  formatDate,
  formatUtcDate,
  formatLongDate,
  formatDateTime,
  formatDateRange,
  fromNow,
  formatAudienceComposition,
  formatTV,
} from "@/helpers/filters";
import "@/mixins/Can";
import Highcharts from "highcharts";
import Maps from "highcharts/modules/map";
import HighchartsExport from "highcharts/modules/exporting";
import HighchartsVue from "highcharts-vue";
import loadHighchartsMore from "highcharts/highcharts-more.js";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { WebSocketsPlugin } from "@/lib/websocket/plugin";
import router from "@/router";
import { createPinia } from "pinia";
import vuetify from "@/plugins/vuetify";
import { userMixin } from "@/mixins/Can.js";

const app = createApp(App);
app.use(router);
app.mixin(userMixin);
app.mixin(DisableAutocomplete);

Maps(Highcharts);
HighchartsExport(Highcharts);
// needed for the gauge chart
loadHighchartsMore(Highcharts);
Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});
// Vite 8/Rolldown wraps this CJS package's default export; unwrap so app.use
// receives the install function rather than the module namespace.
app.use(HighchartsVue.default ?? HighchartsVue);
app.component("VueDatePicker", VueDatePicker);

const pinia = createPinia();
app.use(pinia);
app.use(WebSocketsPlugin, { pinia });
app.use(vuetify);

app.config.globalProperties.$filters = {
  pluralize,
  titleize,
  abbreviateNumber,
  audienceAvailability,
  audienceType,
  formatDate,
  formatUtcDate,
  formatLongDate,
  formatDateTime,
  formatDateRange,
  fromNow,
  formatAudienceComposition,
  formatTV,
};

pinia.use(() => ({
  $pluralize: markRaw(pluralize),
}));

app.mount("#app");
